// extracted by mini-css-extract-plugin
export default {"maskTabPanelContent":"maskTabPanelContent--zIVF2"};